import { EntityAdapter, EntityState, createEntityAdapter } from "@ngrx/entity";

import { CallState, LoadingState } from "@core/models";

import { ILabelPrinter } from "@shared/models";
import { sortByName } from "../sort-by-name";



export interface LabelPrintersState extends EntityState<ILabelPrinter> {
  callState: CallState;
}

export const labelPrintersAdapter: EntityAdapter<ILabelPrinter> =
  createEntityAdapter<ILabelPrinter>({
    selectId: (x) => x.id,
    sortComparer: sortByPrimaryAndName
  });

export const initialState: LabelPrintersState = labelPrintersAdapter.getInitialState({
  callState: LoadingState.INIT,
});

/*
Sorter
*/
function sortByPrimaryAndName(a: ILabelPrinter, b: ILabelPrinter) {
  if (!a.isPrimary && b.isPrimary) { return 1;}
  if (a.isPrimary && !b.isPrimary) { return -1;}

  return sortByName(a, b);
}